module.exports = __webpack_public_path__ + "static/img/3.519b481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/3.jpg
// module id = IWkz
// module chunks = 0